import React, { useEffect, useState, useContext } from "react";
import Header from "./Header";
import "../css/CommonStyle.css";
import "../css/ItemDetails.css";
import ic_mirror_1 from "../img/ic_mirror_1.png";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { ShoppingCartContext } from "./ShoppingCartContext";
import CartSidebar from "./CartSidebar";

function ItemDetails() {

    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext)

    const [showCartSidebar, setShowCartSidebar] = useState(false)

    const [thumbnailImagePosition, setThumbnailImagePosition] = useState(1);

    const [itemSpecificationDetails, setItemSpecificationDetails] = useState(null);

    const [itemSingleDetails, setItemSingleDetails] = useState(null);

    const [searchParams, setSearchParams] = useSearchParams();

    const product_id = searchParams.get("prod_id")

    let specialCharacterRemovedItemCode = encodeURIComponent(product_id);

    console.log("product_id is ", product_id);

    const navigate = useNavigate();

    const clickedOnCart = () => {
        navigate('/cart')
    }

    const getProductDetailsAPI = (productIdToSearch) => {


        let specialCharacterRemovedItemCode = encodeURIComponent(productIdToSearch);

        let apiUrl = `https://cbixapi.buraqstar.com/api/CUBIXITEMS/single/${specialCharacterRemovedItemCode}`;
        axios.get(apiUrl).then(res => {
            console.log("getting product details")
            console.log(res.data);
            setItemSingleDetails(res.data);
        }).catch(err => console.log("error in single item ", err));
    }

    const getSpecificationDetailsAPI = (productIdToSearch) => {

        let specialCharacterRemovedItemCode = encodeURIComponent(productIdToSearch);

        let apiUrl = `https://cbixapi.buraqstar.com/api/CUBIXITEMS/details/${specialCharacterRemovedItemCode}`;
        axios.get(apiUrl).then(res => {
            console.log("getting product specifications")
            console.log(res.data);
            setItemSpecificationDetails(res.data);
        }).catch(err => console.log("error in single item ", err));
    }

    useEffect(() => {

        getProductDetailsAPI(product_id);
        getSpecificationDetailsAPI(product_id)

    }, [])

    const handleThumbnailClick = (position) => {
        setThumbnailImagePosition(position);
    }

    const checkIfItemAlreadyPresentInCart = (itemCodeFromParent) => {
        return shoppingCart.some((itemInArray) => {
            return itemInArray.code == itemCodeFromParent
        })
    }

    const clickedOnShoppingCart = (codeFromClick, descriptionFromClick, priceFromClick) => {

        let itemObjectToStoreInArray = { code: codeFromClick, price: priceFromClick, product_name: descriptionFromClick }

        console.log("current context is shoppingCart ", shoppingCart, itemObjectToStoreInArray)

        let updatedItemWithQuantity = { ...itemObjectToStoreInArray, quantity_in_shopping_cart: 1 }

        if (shoppingCart.length != 0) {

            if (checkIfItemAlreadyPresentInCart(codeFromClick)) {

                const updatedArrayWithQuantityIncremented = shoppingCart.map((itemInArray) => {
                    if (itemInArray.code == codeFromClick) {
                        return { ...itemInArray, quantity_in_shopping_cart: itemInArray.quantity_in_shopping_cart + 1 }
                    } else {
                        return itemInArray
                    }
                })

                setShoppingCart(updatedArrayWithQuantityIncremented)

            } else {
                setShoppingCart([...shoppingCart, updatedItemWithQuantity])
            }


        } else {
            setShoppingCart([updatedItemWithQuantity])
        }

        // now show sidebar optimise it to show after items updated is confirmed

        setShowCartSidebar(true)
    }

    return (
        <div className="ItemDetails-root-container common_page_bg">



            <Header />

            <div className="ItemDetails-top-and-bottom-container">

                {
                    itemSingleDetails != null &&
                    <div className="ItemDetails-top-container container">

                        <div className="ItemDetails-thumbnail-main-image-container">
                            <div className="ItemDetails-thumbnail-container">
                                <img src={`https://buraqstar.com/buraq_web_admin_backend/buraqimg/img2/${specialCharacterRemovedItemCode}_thumbnail_1.jpg`} onError={(event) => event.target.style.display = 'none'} onClick={() => handleThumbnailClick(1)} />
                                <img src={`https://buraqstar.com/buraq_web_admin_backend/buraqimg/img2/${specialCharacterRemovedItemCode}_thumbnail_2.jpg`} onError={(event) => event.target.style.display = 'none'} onClick={() => handleThumbnailClick(2)} />
                                <img src={`https://buraqstar.com/buraq_web_admin_backend/buraqimg/img2/${specialCharacterRemovedItemCode}_thumbnail_3.jpg`} onError={(event) => event.target.style.display = 'none'} onClick={() => handleThumbnailClick(3)} />
                                <img src={`https://buraqstar.com/buraq_web_admin_backend/buraqimg/img2/${specialCharacterRemovedItemCode}_thumbnail_4.jpg`} onError={(event) => event.target.style.display = 'none'} onClick={() => handleThumbnailClick(4)} />
                                <img src={`https://buraqstar.com/buraq_web_admin_backend/buraqimg/img2/${specialCharacterRemovedItemCode}_thumbnail_5.jpg`} onError={(event) => event.target.style.display = 'none'} onClick={() => handleThumbnailClick(5)} />
                            </div>
                            <div className="ItemDetails-main-image-container">
                                <img src={`https://buraqstar.com/buraq_web_admin_backend/buraqimg/img1/${specialCharacterRemovedItemCode}_${thumbnailImagePosition}.jpg`} />
                            </div>
                        </div>

                        <div className="ItemDetails-short-details-wrapper">
                            <div className="ItemDetails-short-details-container">
                                <div>{itemSingleDetails[0].Code}</div>
                            </div>
                            <div>
                                <label className="ItemDetails-item-name">
                                    {itemSingleDetails[0].Description}
                                </label>
                            </div>
                            <div className="mt-3">
                                <h6>About this item</h6>
                                {
                                    itemSpecificationDetails != null ?
                                        itemSpecificationDetails.filter(item => item.type == "Specifications").map((item) => {
                                            return (

                                                <p className="ItemDetails-about-this-item-paragraph">{item.details}</p>
                                            )
                                        })
                                        :
                                        null
                                }
                            </div>

                            <div className="mt-3">
                                AED {itemSingleDetails[0].Selprice}
                            </div>
                            <div className="mt-4">
                                Quantity
                                <input className="ItemDetails-quantity-input ms-2" type="number" />
                            </div>
                            <div className="mt-4">
                                <button className="btn btn-danger" onClick={() => clickedOnShoppingCart(itemSingleDetails[0].Code, itemSingleDetails[0].Description, itemSingleDetails[0].Selprice)}>Add to Cart</button>
                            </div>
                        </div>
                    </div>
                }


                {itemSpecificationDetails != null &&
                    <div className="ItemDetails-Technical-details-container container mt-4">
                        <div>
                            <h6 >TECHNICAL DETAILS</h6>
                        </div>

                        <table className="ItemDetail-table">

                            <tbody>
                                {
                                    itemSpecificationDetails.map((item) => {

                                        return (
                                            <tr>
                                                <td><div className="WorkDetailPage-table_requested_item_code_column">{item.type}</div></td>
                                                <td><div className="WorkDetailPage-table_requested_quantity_column">{item.details}</div></td>
                                            </tr>
                                        )
                                    })
                                }



                            </tbody>
                        </table>

                    </div>
                }
            </div>

            {
                showCartSidebar &&
                <CartSidebar setShowCartSidebar={setShowCartSidebar} />
            }

        </div>
    )
}

export default ItemDetails;